export const environment = {
  API_URI: 'https://api.204.zetta-demo.space/graphql',
  ENV: 'STAGING',
};
